import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative bg-[#050505] py-24 md:py-40 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/5]">
              <motion.img
                style={{ y }}
                src={IMAGES.angeloFront}
                alt="Angelo Quitugua, personal trainer"
                className="w-full h-[115%] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#e5ff00] text-black px-6 py-4 rounded-xl">
              <div className="font-display uppercase text-2xl leading-none">
                Las Vegas
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold mt-1">
                Nevada
              </div>
            </div>
          </div>

          <div>
            <Reveal>
              <span className="text-xs uppercase tracking-[0.3em] text-[#e5ff00]">
                Your Coach
              </span>
              <h2 className="mt-5 font-display uppercase text-4xl md:text-6xl leading-[0.9]">
                Meet
                <br />
                Angelo Quitugua
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-7 text-white/70 text-lg leading-relaxed">
                I don't coach from a 9-to-5 textbook. I coach for the people
                who keep Vegas running after midnight — bartenders, servers,
                hosts, dealers and everyone living on the wrong side of the
                clock.
              </p>
              <p className="mt-5 text-white/60 leading-relaxed">
                No lectures about sleeping at 10PM and eating chicken and rice.
                Just tactical, real-world strategies to build a leaner, stronger
                body while thriving in the industry — on your schedule, not
                someone else's.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-9 flex flex-wrap gap-3">
                {["Body Recomposition", "Shift Nutrition", "Home & Hybrid Training"].map(
                  (t) => (
                    <span
                      key={t}
                      className="text-xs uppercase tracking-[0.15em] text-white/70 border border-white/15 rounded-full px-4 py-2"
                    >
                      {t}
                    </span>
                  )
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
